import { render, staticRenderFns } from "./Associar.vue?vue&type=template&id=5b6cf3ce"
import script from "./Associar.vue?vue&type=script&lang=js"
export * from "./Associar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports